const Footer = () => {
  return (
    <footer className="bg-[#5A5A5C] text-white py-6 text-center">
      <p>
        © פותח ע"י{' '}
        <span>
          איטי דונט
        </span>
        {' '}
        עבור השכורית
      </p>
    </footer>
  );
}
export default Footer;